"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IConstantFlowAgreementHook__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "sender",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "receiver",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "flowOperator",
                        type: "address",
                    },
                    {
                        internalType: "int96",
                        name: "flowRate",
                        type: "int96",
                    },
                ],
                internalType: "struct IConstantFlowAgreementHook.CFAHookParams",
                name: "newFlowData",
                type: "tuple",
            },
        ],
        name: "onCreate",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "sender",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "receiver",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "flowOperator",
                        type: "address",
                    },
                    {
                        internalType: "int96",
                        name: "flowRate",
                        type: "int96",
                    },
                ],
                internalType: "struct IConstantFlowAgreementHook.CFAHookParams",
                name: "newFlowData",
                type: "tuple",
            },
            {
                internalType: "int96",
                name: "oldFlowRate",
                type: "int96",
            },
        ],
        name: "onDelete",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "sender",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "receiver",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "flowOperator",
                        type: "address",
                    },
                    {
                        internalType: "int96",
                        name: "flowRate",
                        type: "int96",
                    },
                ],
                internalType: "struct IConstantFlowAgreementHook.CFAHookParams",
                name: "newFlowData",
                type: "tuple",
            },
            {
                internalType: "int96",
                name: "oldFlowRate",
                type: "int96",
            },
        ],
        name: "onUpdate",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IConstantFlowAgreementHook__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.IConstantFlowAgreementHook__factory = IConstantFlowAgreementHook__factory;
IConstantFlowAgreementHook__factory.abi = _abi;
//# sourceMappingURL=IConstantFlowAgreementHook__factory.js.map